/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFastEndpointsInternalErrorResponseFromDiscriminatorValue, createWebhusetOrderApiFeaturesCartOrderPrepareResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartOrderPrepareRequest, serializeWebhusetOrderApiFeaturesCartOrderPrepareResponse, type FastEndpointsInternalErrorResponse, type WebhusetOrderApiFeaturesCartOrderPrepareRequest, type WebhusetOrderApiFeaturesCartOrderPrepareResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/order-prepare
 */
export interface OrderPrepareRequestBuilder extends BaseRequestBuilder<OrderPrepareRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartOrderPrepareResponse>}
     * @throws {FastEndpointsInternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: WebhusetOrderApiFeaturesCartOrderPrepareRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartOrderPrepareResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartOrderPrepareRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrderPrepareRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/order-prepare";
/**
 * Metadata for all the requests in the request builder.
 */
export const OrderPrepareRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: OrderPrepareRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            500: createFastEndpointsInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartOrderPrepareResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartOrderPrepareRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
